import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    idx: -1,        // ROI Modal
    widx: false,   //walletModal
    processidx: 0,   // For pool data fetch
}
const slice = createSlice({
    name: 'Index',
    initialState: {
        ...initialState
    },
    reducers: {
        setIdx: (data, action) => {
            data.idx = action.payload;
        },
        setWidx: (data, action) => {
            data.widx = action.payload;
        },
        setPidx: (data, action) => {
            data.processidx = action.payload;
        }
    }
})
export const { setIdx, setWidx, setPidx } = slice.actions;
export default slice.reducer
export const getIdx = state => {
    return state.LPLock;
}